import { useState } from 'react';

export const useMarquee = (): [addChildWidth: (elemWidth: number) => void, maxWidth: number, reset: () => void] => {
    const [maxWidth, setMaxWidth] = useState<number>(0);
    const addChild = (elemWidth: number): void => {
        if (elemWidth > maxWidth) setMaxWidth(elemWidth);
    };
    const reset = () => setMaxWidth(0);
    
    return [addChild, maxWidth, reset];
};